import { Fragment } from "react";
import { Transition } from "@headlessui/react";
import { XIcon } from "@heroicons/react/solid";
import { useTranslation } from "react-i18next";

export default function Alert({ alert, setAlert, message, type = "error" }) {
  const { t } = useTranslation();

  // Mesaja göre tip belirle (fallback)
  const isSuccess = type === "success" ||
    message?.toLowerCase().includes("başarı") ||
    message?.toLowerCase().includes("success") ||
    message?.toLowerCase().includes("eklendi");

  const bgColor = isSuccess ? "bg-green-500" : "bg-red-400";

  return (
    <>
      {alert && (
        <div
          aria-live="assertive"
          className="absolute top-16 left-0 right-0 z-50 flex justify-center px-4 py-6 pointer-events-none sm:p-6"
        >
          <div className="w-full flex flex-col items-center space-y-4">
            <Transition
              show={alert}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className={`max-w-sm w-full ${bgColor} shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden`}>
                <div className="p-4">
                  <div className="flex items-center">
                    <div className="w-0 flex-1 flex justify-between">
                      <p className="w-0 flex-1 text-sm font-medium text-white">
                        {message}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
      )}
    </>
  );
}
